import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, map, Observable } from 'rxjs';
import { VendorService } from '../../services/vendor-service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatSpinner,
    MatPaginatorModule
  ],
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']  
})
export class OrderDetailsComponent implements OnInit {
  orderId!: string;
  isLoading = false;
  orderDetails$!: Observable<any[]>;
  constructor(private route: ActivatedRoute, private vendorService: VendorService,private router: Router) { }
  displayedColumns: string[] = [
    'slno',
    'name',
    'date',
    'amount_untaxed'
    // 'payment_status'
  ];
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.orderId = this.route.snapshot.paramMap.get('id')!;
    this.getOrderDetails();
  }

  getOrderDetails() {
    this.isLoading = true;
    this.orderDetails$ = this.vendorService.getOrderDetailsByID(Number(this.orderId)).pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

   onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
